<script lang="ts">
    import { page } from '$app/stores';
    import { useLocaleContext } from '$lib/context';

    const lang = useLocaleContext();
</script>

<a
    href={'/de' + $page.url.pathname.slice(3)}
    data-sveltekit-reload
    class="relative text-shadow mr-6 lg:mr-3 font-normal transition-colors text-[#E5E5E5] sm:text-secondary text-sm sm:text-[16px]
{lang === 'de' ? `after:content-['']` : 'after:content-none'}
after:w-full after:border-b-2 after:border-primary after:absolute after:-bottom-1.5 after:left-0 after:transition-colors"
    >DE
</a>

<a
    href={'/en' + $page.url.pathname.slice(3)}
    data-sveltekit-reload
    class="relative text-shadow font-normal transition-colors text-[#E5E5E5] sm:text-secondary text-sm sm:text-[16px]
{lang === 'en' ? `after:content-['']` : 'after:content-none'}
after:w-full after:border-b-2 after:border-primary after:absolute after:-bottom-1.5 after:left-0 after:transition-colors"
    >EN
</a>
